module.exports = __webpack_public_path__ + "media/images/massage/card-mobile-aa961c0eac120fed8b07340cce7800ba.jpg";